// Function to check if a specific variant exists in the cart JSON
function checkCartItemAndApplyDiscount(variantId, discountCode) {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      var itemFound = false;

      // Loop through the cart items
      for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];

        // Check if the variant ID matches
        if (item.variant_id == variantId) {
          itemFound = true;
          break;
        }
      }

      // Apply or remove the discount code based on the result
      if (itemFound) {
        window.location.href = "/cart/checkout?&discount=TESTVIPMEMBER";
      } else {
        window.location.href = "/cart/checkout?&discount=''";
      }
    })
    .catch(error => {
      console.error('Error fetching cart JSON:', error);
    });
}

$(document).ready(function() {
    // Add a click event handler to the button
  $('#checkoutdrower').click(function(event) {
    // Usage example
    var variantIdToCheck = '45478915670208'; // Replace with your variant ID
    var discountCodeToApply = 'TESTVIPMEMBER'; // Replace with your discount code
    
    checkCartItemAndApplyDiscount(variantIdToCheck, discountCodeToApply);
  });
    
    $(document).on("click", '.popup_product_add, .membership_signup_btn', function(event) {
      event.preventDefault();
      jQuery("body").addClass("disabled-active");
      //var variant_first_id = jQuery("body").attr("first-id");
           $.ajax({
              type: 'POST',
              url: '/cart/add',
              data: {
                  "id": 45478915670208,
                  "quantity": 1,
                  "selling_plan": 2255192256
              },
              dataType: 'json',
              success: function() {
                //console.log("first product added into cart")
                //setTimeout(function() {
                // var variant_second_id = jQuery("body").attr("second-id");
                 $.ajax({
                    type: "POST",
                    url: "/cart/add",
                    data: {
                      id: 45452776931520,
                      quantity: 1,
                    },
                    dataType: "json",
                    success: function(data) {
                      console.log("Second product added to cart successfully");
                        var winLocRef = window.location.href;
                        if( winLocRef.includes("hero-vip-club-unlock-split-test") || winLocRef.includes("stra-vip-club-unlock") || winLocRef.includes("vip-club-unlock") ){
                          window.location.href = "/cart";
                        } else {
                          location.reload();
                        }
                        jQuery("body").removeClass("disabled-active");
                    },
                    error: function(xhr, status, error) {
                      console.log("Error adding second product to cart: " + error);
                    }
                });
               //}, 1000);
              }
            });
    });
  
    $('.HeroVIPClub').click(function(e) {
        var dialogResult = "";
          $.confirm({
              title: 'Are you sure you want to remove "STRĀ VIP Club" from cart?',
              content: 'Removing "STRĀ VIP Club" product will refresh your cart and remove discount coupon, free product from your cart!',
              buttons: {
                  Yes: function () {
                      dialogResult = "Yes";

                    //window.location.href = '/cart/clear';

                              // Get the line item IDs and quantities for the products to be removed
                              var data = {
                                "updates": {
                                  "45478915670208": 0,
                                  "45452776931520": 0,
                                  // "46436299505856": 0,
                                  // "46579815874752": 0
                                }
                              };
                                e.preventDefault();
                              // Make an AJAX request to remove the products from the cart
                              $.ajax({
                                type: 'POST',
                                url: '/cart/update.js',
                                data: data,
                                dataType: 'json',
                                success: function() {
                                  // If the request is successful, redirect the user to the cart page
                                  window.location.href = '/cart';
                                }
                              });



                  },
                  No: function () {
                      dialogResult = "No";
                      e.preventDefault();
                  },
              }
          });
      });
 // Override the form submission for ambassador-checkout class
$(document).on("click", '.ambassador-checkout', function(event) {
    event.preventDefault();
    jQuery("body").addClass("disabled-active");

    var firstProductVariantId = '46436299505856';
    var sellingPlanId = 2710044864; // Your selling plan ID

    // Default second variant
    var secondProductVariantId = '46579815874752';

    // Check if URL ends with jewelry-club-2
    if (window.location.href.endsWith('/pages/jewelry-club-2')) {
        secondProductVariantId = '47256335974592';
    }

    // Add first product with selling plan
    $.ajax({
        type: 'POST',
        url: '/cart/add',
        data: {
            id: firstProductVariantId,
            quantity: 1,
            selling_plan: sellingPlanId
        },
        dataType: 'json',
        success: function(data) {

            // Add second product
            $.ajax({
                type: "POST",
                url: "/cart/add",
                data: {
                    id: secondProductVariantId,
                    quantity: 1,
                },
                dataType: "json",
                success: function(data) {
                    window.location.href = "/cart";
                    jQuery("body").removeClass("disabled-active");
                },
                error: function(xhr, status, error) {
                    jQuery("body").removeClass("disabled-active");
                    alert("Error adding second product to cart. Please try again.");
                }
            });
        },
        error: function(xhr, status, error) {
            jQuery("body").removeClass("disabled-active");
            alert("Error adding first product to cart. Please try again.");
        }
    });
});

    // // If you're using buttons instead of forms, use this click handler
    // $(document).on("click", '.ambassador-checkout', function(event) {
    //     event.preventDefault();
    //     event.stopPropagation();
        
    //     // Trigger the same logic as form submission
    //     $(this).closest('form').trigger('submit');
        
    //     // If there's no form, run the logic directly
    //     if ($(this).closest('form').length === 0) {
    //         jQuery("body").addClass("disabled-active");
            
    //         // Replace these with your actual product variant IDs
    //         var firstProductVariantId = 'YOUR_FIRST_PRODUCT_VARIANT_ID';
    //         var secondProductVariantId = 'YOUR_SECOND_PRODUCT_VARIANT_ID';
    //         var sellingPlanId = 2710044864;
            
    //         // Add first product with selling plan
    //         $.ajax({
    //             type: 'POST',
    //             url: '/cart/add',
    //             data: {
    //                 "id": firstProductVariantId,
    //                 "quantity": 1,
    //                 "selling_plan": sellingPlanId
    //             },
    //             dataType: 'json',
    //             success: function(data) {
    //                 console.log("First product added to cart successfully");
                    
    //                 // Add second product
    //                 $.ajax({
    //                     type: "POST",
    //                     url: "/cart/add",
    //                     data: {
    //                         id: secondProductVariantId,
    //                         quantity: 1,
    //                     },
    //                     dataType: "json",
    //                     success: function(data) {
    //                         console.log("Second product added to cart successfully");
                            
    //                         var winLocRef = window.location.href;
    //                         if(winLocRef.includes("hero-vip-club-unlock-split-test")){
    //                             window.location.href = "/cart";
    //                         } else {
    //                             location.reload();
    //                         }
                            
    //                         jQuery("body").removeClass("disabled-active");
    //                     },
    //                     error: function(xhr, status, error) {
    //                         console.log("Error adding second product to cart: " + error);
    //                         jQuery("body").removeClass("disabled-active");
    //                         alert("Error adding second product to cart. Please try again.");
    //                     }
    //                 });
    //             },
    //             error: function(xhr, status, error) {
    //                 console.log("Error adding first product to cart: " + error);
    //                 jQuery("body").removeClass("disabled-active");
    //                 alert("Error adding first product to cart. Please try again.");
    //             }
    //         });
    //     }
    // });
      $('button#checkout').on('click', function(e){
        e.preventDefault();
      
        fetch('/cart.js')
        .then(res => res.json())
        .then(data => {
            let hasItem = false;
            let ids = [];
            let variantIdToCheck = 45478915670208;
           
            let items = data.items;
          
            items.map((item, index) => {
              ids.push(item.variant_id);
            });
            
            if(ids.includes(variantIdToCheck)){
              window.location.href ="/cart/checkout/?discount=VIPMEMBEROFF";
            } else {
              window.location.href ="/cart/checkout/?discount=ADD_VIP_PRODUCT_TO_THE_CART_FOR_DISCOUNT";
            }
            
        })
        .catch(err => console.log(err));
    });


    if( jQuery(".outer_vipcustomer_footerbanner").length >= 1 ){
        jQuery(".outer_vipcustomer_footerbanner").each(function(index){
          if( index > 0 && index != 0 ){
              jQuery(this).remove();
          }
        });
      }
  });

  
  
  setInterval(function () {
    if( jQuery(".custom__checkout").length >= 1 ){
     jQuery(".popup_product_add").each(function(){
         jQuery(this).remove();
     });
    }
    if( jQuery('.cart__item a[href*="stra-vip-club"]').length >= 1 ){
      jQuery(".outer_vipcustomer_footerbanner").remove();
    }
  });

  